import {patchState, signalStoreFeature, type, withMethods} from '@ngrx/signals';
import {Answer} from '../../models/answer.model';
import {
  setAnswer,
  setAnswerLegendUrl,
  setAnswerOptions,
  restoreGuesses,
  setGuesses,
} from '../game.operators';
import {GameFeatureInput} from './feature-input';

/**
 * Contributes the answer/guess interactions for the current question.
 */
export function withAnswers() {
  return signalStoreFeature(
    type<GameFeatureInput>(),
    withMethods((store) => ({
      /** Replaces the answer options for the current question. */
      setAnswerOptions(options: Answer[]): void {
        patchState(store, setAnswerOptions(options));
      },
      /** Replaces the guesses for the current question. */
      setGuesses(guesses: Answer[]): void {
        patchState(store, setGuesses(guesses));
      },
      /**
       * Restores rehydrated guesses after a refresh, removing their features
       * from the remaining answer options without altering the question state.
       */
      restoreGuesses(guesses: Answer[]): void {
        patchState(store, restoreGuesses(guesses));
      },
      /** Sets the name of the correct answer feature. */
      setAnswer(answer: string): void {
        patchState(store, setAnswer(answer));
      },
      /** Sets the legend url of the currently shown answer layer. */
      setAnswerLegendUrl(url: string): void {
        patchState(store, setAnswerLegendUrl(url));
      },
    }))
  );
}
